/**
 * Definition of different API responses
 * 
 * @author - Harsh Tomar
 */

export enum PlanName {
  FREE_TRIAL = 'free_trial',
  LTD = 'ltd',
  TRIAL_EXPIRED = 'trial_expired'
}

export type UserResponse = {
  _id: string;
  name: string;
  email: string;
  alertTo: {type: string, to: string}[];
  planName: PlanName;
  createdAt: Date;
  updatedAt: Date;
  lastLoggedIn: Date;
  purchasedOn?: string;
}

export type PingResponse = {
  _id: string;
  type: "SSL_MONITORING";
  status: "SUCCESS" | "FAILURE";
  monitor: string;
  meta: {
    authorizationError: any;
    issuedBy: string;
    validFrom: string;
    validTo: string;
    code?: string;
  }
  createdAt: string;
}

export type MonitorsResponse = {
  _id: string;
  url: string;
  type: "SSL_MONITORING" | "API" | "WEBSITE";
  status: "ACTIVE" | "PAUSED" | "EXPIRING_SOON"| "EXPIRED";
  latestPing: PingResponse;
  lastPingHash: string;
  createdAt: string;
  alertTo: {
    type: "EMAIL";
    to: string;
  }[]
}